import './assets/reset.css'
import './assets/tooltip.css'

import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
import moment from 'moment'

Vue.config.productionTip = false

Vue.use(VTooltip)

Vue.filter('daysSince', function (value) {

	return (value) ? moment().utc().diff(moment.unix(value).utc(), 'days') : ''

})

Vue.filter('prettyNumber', function (value) {

	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

})

Vue.filter('fromNow', function (value, plain) {

	return (value) ? moment.unix(value).local().fromNow(plain || false) : ''

})

new Vue({
	render: h => h(App),
}).$mount('#app')
